import { Redirect, useLocalSearchParams } from 'expo-router';

export default function CreateAccount() {
  const params = useLocalSearchParams<Record<string, string>>();

  const query = new URLSearchParams(params as Record<string, string>).toString();

  return <Redirect href={`/create-account/step-1${query ? `?${query}` : ''}` as any} />;
}
